export enum TrafficDeviationInformationAdvancedOptions {
    BOARD_ONLY = 'BOARD_ONLY',
    STOP_INDEPENDENT = 'STOP_INDEPENDENT',
    EXCLUSIVE = 'EXCLUSIVE',
  }